



































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class AppFooter extends Vue {
  private get hideGooglePlayButton(): boolean {
    return this.$route.query.hide_google_play === 'true';
  }
}
